/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListGcpNetworksResponseNetworksInner {
  /**
  * The name of the network
  */
  'networkName': string;
  /**
  * The project that owns the network
  */
  'project': string;
  /**
  * Whether the network is peered with Google\'s Service Networking for CloudSQL private instances
  */
  'isPeered': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "networkName",
      "baseName": "networkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "project",
      "baseName": "project",
      "type": "string",
      "format": ""
    },
    {
      "name": "isPeered",
      "baseName": "isPeered",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListGcpNetworksResponseNetworksInner.attributeTypeMap;
  }

  public constructor() {
  }
}

